<div class="setup-conversations">
  <div [id]="reactWrapperId">
    <!-- React component will be rendered inside this div -->
  </div>
</div>
